import numericStringToFloat from 'services/numbers/numericStringToFloat';

// The margin % of a row below this is shown with a red border, above the high one green
export const LOW_MARGIN_PERCENT = 20;
export const HIGH_MARGIN_PERCENT = 30;

/** The class of a margin %, compared as shown (two decimals) */
export const getMarginClass = (contributionMarginRatio: number): string => {
  const shownRatio = Math.round(contributionMarginRatio * 100) / 100;

  if (shownRatio < LOW_MARGIN_PERCENT) {
    return 'margin-low';
  }

  return shownRatio > HIGH_MARGIN_PERCENT ? 'margin-high' : '';
};

/**
 * The class of the margin % cell of a row by its margin. A row without a selling price
 * has no margin to show yet.
 */
export default (
  contributionMarginRatio: number,
  sellingPrice: string
): string =>
  numericStringToFloat(sellingPrice)
    ? getMarginClass(contributionMarginRatio)
    : '';
